export const convertTime = (time: string) => {
  return new Date(time).toLocaleDateString("en-us", {
    year: "numeric",
    month: "short",
    day: "numeric",
    // weekday: "long",
  });
};

// lang: en-gb or en-us
